import { type ReactNode } from 'react'

import { type CustomField } from '@webapp/core/entities/internal/CustomField'
import { POCustomFieldConfigTable } from '@webapp/modules/purchasing/features/list-po-custom-field-configs/views/POCustomFieldConfigTable'
import { usePOCustomFieldConfigListPresenter } from './usePOCustomFieldConfigListPresenter'

export interface IPOCustomFieldConfigListPresenterProps {
  onDeleteField?: (field: CustomField) => void
  renderNameCell?: (field: CustomField) => ReactNode
}

export const POCustomFieldConfigListPresenter = ({
  onDeleteField,
  renderNameCell,
}: IPOCustomFieldConfigListPresenterProps) => {
  const {
    data: { fields, numPages },
    states: { page, isLoading },
    methods: { onPrevPage, onNextPage },
  } = usePOCustomFieldConfigListPresenter()

  return (
    <POCustomFieldConfigTable
      fields={fields}
      isLoading={isLoading}
      page={page}
      numPages={numPages}
      onPrevPage={onPrevPage}
      onNextPage={onNextPage}
      onDeleteField={onDeleteField}
      renderNameCell={renderNameCell}
    />
  )
}

POCustomFieldConfigListPresenter.displayName =
  'POCustomFieldConfigListPresenter'
